import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async validateCpfCrm(body: ApiSchemas['BulkValidateCrmWithCpfDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/cfm/crm/bulk-validate-with-cpf', {
        body,
      }),
    )
  },
}
